<div>
  <div mat-dialog-title>
    <span>
      {{ data.title | translate }}
    </span>
  </div>

  <div mat-dialog-content>
    <span>
      {{ data.content | translate }}
    </span>
  </div>

  @if (!data.hideDontShowAgain) {
    <mat-checkbox
      [(ngModel)]="dontShowAgain"
    >
      {{ 'TRANS__PAGINATION__WARNING_HIDE_DIALOG' | translate }}
    </mat-checkbox>
  }

  <div mat-dialog-actions>
    <button
      mat-flat-button
      color="primary"
      (click)="dialogRef.close(false)"
    >
      <span>
        {{ data.cancelButtonText ?? 'TRANS__CONFIRM_DIALOG__SUBMIT' | translate }}
      </span>
    </button>

    <button
      mat-button
      color="primary"
      (click)="confirm()"
    >
      <span>
        {{ data.confirmButtonText ?? 'TRANS__CONFIRM_DIALOG__SUBMIT' | translate }}
      </span>
    </button>
  </div>
</div>
